module.exports = __webpack_public_path__ + "static/media/restoran.a6d3cb5b.png";